import React, { useState, useEffect } from 'react';
import Icon from './Icon';

export default function RemoteDesktopModal({ computer, onClose }) {
  const [status,   setStatus]   = useState('connecting'); // connecting | opened | error
  const [errorMsg, setErrorMsg] = useState('');
  const [rdUrl,    setRdUrl]    = useState(null);

  const h = () => ({ Authorization: `Bearer ${localStorage.getItem('hd_token')}` });

  useEffect(() => {
    fetch(`/api/computers/${computer.id}/mesh-url`, { headers: h() })
      .then(r => r.json())
      .then(data => {
        if (data.ok && data.url) {
          setRdUrl(data.url);
          setStatus('opened');
          window.open(data.url, '_blank', 'noopener,noreferrer');
        } else {
          setErrorMsg(data.error || 'No se pudo obtener la URL de MeshCentral');
          setStatus('error');
        }
      })
      .catch(e => {
        setErrorMsg('Error de red: ' + e.message);
        setStatus('error');
      });
  }, [computer.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24, background: 'rgba(0,0,0,.65)', backdropFilter: 'blur(4px)',
    }} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{
        width: 480, borderRadius: 14,
        background: '#1a1a1a',
        display: 'flex', flexDirection: 'column',
        overflow: 'hidden',
        boxShadow: '0 24px 64px rgba(0,0,0,.6)',
        border: '1px solid rgba(255,255,255,.08)',
      }}>
        {/* Top bar */}
        <div style={{
          height: 44, background: '#111',
          display: 'flex', alignItems: 'center',
          padding: '0 14px', gap: 10, flexShrink: 0,
          borderBottom: '1px solid rgba(255,255,255,.08)',
        }}>
          <div style={{
            width: 8, height: 8, borderRadius: '50%', flexShrink: 0,
            background: status === 'opened' ? '#22C55E' : status === 'error' ? '#EF4444' : '#F59E0B',
            boxShadow: status === 'opened' ? '0 0 6px #22C55E' : 'none',
          }}/>
          <Icon name="desktop_windows" size={14} style={{ color: '#6B7280' }}/>
          <span style={{ fontSize: 13, fontWeight: 700, color: '#F9FAFB' }}>{computer.hostname}</span>
          {computer.local_ip && (
            <span style={{ fontSize: 11, color: '#6B7280' }}>· {computer.local_ip}</span>
          )}
          <div style={{ flex: 1 }}/>
          <button onClick={onClose} style={{
            width: 28, height: 28, borderRadius: 6, border: 'none',
            background: 'rgba(239,68,68,.15)', color: '#F87171', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Icon name="close" size={16} style={{ color: '#F87171' }}/>
          </button>
        </div>

        {/* Content */}
        <div style={{
          padding: '36px 32px', display: 'flex', flexDirection: 'column',
          alignItems: 'center', gap: 16, textAlign: 'center',
        }}>
          {status === 'connecting' && (
            <>
              <div style={{
                width: 48, height: 48, borderRadius: '50%',
                border: '3px solid rgba(255,255,255,.1)',
                borderTopColor: '#7C3AED',
                animation: 'spin 1s linear infinite',
              }}/>
              <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
              <div style={{ color: '#9CA3AF', fontSize: 14, fontWeight: 600 }}>
                Conectando con <strong style={{ color: '#F9FAFB' }}>{computer.hostname}</strong>…
              </div>
              <div style={{ color: '#4B5563', fontSize: 12 }}>Buscando equipo en MeshCentral</div>
            </>
          )}

          {status === 'opened' && rdUrl && (
            <>
              <div style={{ fontSize: 40 }}>🖥️</div>
              <div style={{ color: '#4ADE80', fontSize: 15, fontWeight: 700 }}>Escritorio abierto</div>
              <div style={{ color: '#6B7280', fontSize: 12, lineHeight: 1.6 }}>
                Se ha abierto la sesión remota de{' '}
                <strong style={{ color: '#F9FAFB' }}>{computer.hostname}</strong>.
              </div>
              <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
                <a href={rdUrl} target="_blank" rel="noopener noreferrer"
                  style={{
                    padding: '9px 20px', borderRadius: 8, fontSize: 13, fontWeight: 600,
                    background: '#7C3AED', color: '#fff', textDecoration: 'none',
                    display: 'flex', alignItems: 'center', gap: 6,
                  }}>
                  <Icon name="open_in_new" size={14} style={{ color: '#fff' }}/>
                  Abrir de nuevo
                </a>
                <button onClick={onClose} style={{
                  padding: '9px 20px', borderRadius: 8, fontSize: 13, fontWeight: 600,
                  background: 'rgba(255,255,255,.06)', color: '#9CA3AF',
                  border: '1px solid rgba(255,255,255,.1)', cursor: 'pointer',
                }}>
                  Cerrar
                </button>
              </div>
            </>
          )}

          {status === 'error' && (
            <>
              <div style={{ fontSize: 40 }}>⚠️</div>
              <div style={{ color: '#F87171', fontSize: 14, fontWeight: 700 }}>No se pudo conectar</div>
              <div style={{ color: '#6B7280', fontSize: 12, lineHeight: 1.6, maxWidth: 360 }}>
                {errorMsg}
              </div>
              <button onClick={onClose} style={{
                padding: '9px 20px', borderRadius: 8, fontSize: 13, fontWeight: 600,
                background: 'rgba(255,255,255,.06)', color: '#9CA3AF',
                border: '1px solid rgba(255,255,255,.1)', cursor: 'pointer',
              }}>
                Cerrar
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
